module.exports = __webpack_public_path__ + "img/figures-5.1.94947f63.png";